import React from "react"
import styled from "styled-components"
import { Lockup } from "./logo"

const Wrapper = styled.footer`
  background: ${({ theme }) => theme.colors.dark};
  color: ${({ theme }) => theme.colors.textOnDarkMuted};
  border-top: 1px solid ${({ theme }) => theme.colors.borderOnDark};
`

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 64px 32px 32px;
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr;
  gap: 48px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 568px) {
    grid-template-columns: 1fr;
    padding: 48px 20px 24px;
  }
`

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  p {
    font-size: 14px;
    line-height: 1.55;
    max-width: 360px;
  }
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

const ColumnTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.accent};
`

const FooterLink = styled.a`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textOnDarkMuted};

  &:hover {
    color: ${({ theme }) => theme.colors.textOnDark};
  }
`

const Bottom = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px 32px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 10px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(229, 234, 242, 0.45);
  border-top: 1px solid ${({ theme }) => theme.colors.borderOnDark};

  @media (max-width: 568px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px 20px 32px;
  }
`

const Footer = () => (
  <Wrapper>
    <Container>
      <Brand>
        <Lockup
          size={42}
          height={24}
          ink="#F2F4F7"
          accent="#7B8FA8"
          descriptor
          gap={16}
        />
        <p>
          API security where AES-256 encryption begins in the user's browser,
          not at the server's edge.
        </p>
      </Brand>

      <Column>
        <ColumnTitle>Product</ColumnTitle>
        <FooterLink href="#product">Overview</FooterLink>
        <FooterLink href="#architecture">Architecture</FooterLink>
        <FooterLink href="#capabilities">Capabilities</FooterLink>
      </Column>

      <Column>
        <ColumnTitle>Trust</ColumnTitle>
        <FooterLink href="#audience">Audience</FooterLink>
        <FooterLink href="#compliance">Standards</FooterLink>
      </Column>
    </Container>

    <Bottom>
      <span>© {new Date().getFullYear()} Nubizzi Innovative IT, S.L.</span>
      <span>VaultBridge — Powered by MEI Proxy</span>
    </Bottom>
  </Wrapper>
)

export default Footer
